<template>
  <va-custom-sidebar :minimized="minimized">
    <template slot="menu">
      <template v-for="(item, key) in items">
        <va-custom-sidebar-link-group
          :key="key"
          :minimized="minimized"
          :icon="[
            item.meta.iconSet
              ? item.meta.iconSet
              : 'sidebar-menu-item-icon vuestic-iconset',
            item.meta.iconClass,
          ]"
          v-if="item.children"
          :title="reactiveTitle(item.displayName)"
          :children="item.children"
        >
          <va-custom-sidebar-link
            v-for="(subMenuItem, key) in item.children"
            :key="key"
            :to="{ name: subMenuItem.name, params: subMenuItem.params }"
            :title="reactiveTitle(subMenuItem.displayName)"
          />
        </va-custom-sidebar-link-group>
        <va-custom-sidebar-link
          v-else
          :key="key"
          :minimized="minimized"
          :activeByDefault="item.name === $route.name"
          :icon="[
            item.meta.iconSet
              ? item.meta.iconSet
              : 'sidebar-menu-item-icon vuestic-iconset',
            item.meta.iconClass,
          ]"
          :to="{ name: item.name, params: item.params }"
        >
          <span slot="title">{{ reactiveTitle(item.displayName) }}</span>
        </va-custom-sidebar-link>
      </template>
    </template>
  </va-custom-sidebar>
</template>

<script>
import { navigationRoutes } from "./NavigationRoutes";
import vaCustomSidebar from "./custom-sidebar/va-sidebar/VaSidebar";
import vaCustomSidebarLink from "./custom-sidebar/va-sidebar/VaSidebarLink";
import vaCustomSidebarLinkGroup from "./custom-sidebar/va-sidebar/VaSidebarLinkGroup";
import { cloneDeep } from "lodash";
export default {
  name: "app-sidebar",
  components: {
    vaCustomSidebar,
    vaCustomSidebarLink,
    vaCustomSidebarLinkGroup,
  },
  props: {
    minimized: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      items: this.statutsFilter(navigationRoutes.routes),
    };
  },
  methods: {
    reactiveTitle(title) {
      if (!title) {
        return title;
      }
      // hack to get the store to update the title with a fixed import
      // could be solved by defining the route directly in this file or as a module
      let testTitle = title.split("@");
      if (testTitle.length > 1) {
        let replaceVal = false;
        let newTitle = "";
        for (let ijk = 0; ijk < testTitle.length; ijk++) {
          if (replaceVal) {
            let tmpReq = testTitle[ijk].split(".");
            let tmpVar = this.$store.getters[tmpReq[0]];
            for (let klm = 1; klm < tmpReq.length; klm++) {
              tmpVar = tmpVar[tmpReq[ijk]];
            }
            newTitle = newTitle + tmpVar;
          } else {
            newTitle = newTitle + testTitle[ijk];
          }
          replaceVal = !replaceVal;
        }
        return newTitle;
      }
      return title;
    },
    statutsFilter(routes) {
      let filteredRoutes = [];
      // Hack so the developper stay superadmin
      let user = this.$store.getters.user;
      if (
        user.username &&
        (user.username == "Léopold" || user.username == "Pierre-Luc")
      ) {
        return routes;
      }
      //for the rest of the authorization based access
      routes.forEach((route) => {
        let filteredRoute = cloneDeep(route);
        if (route.children) {
          filteredRoute.children = route.children.filter((item) => {
            return this.checkRights(item, user);
          });
        }
        if (this.checkRights(filteredRoute, user)) {
          filteredRoutes.push(filteredRoute);
        }
      });

      return filteredRoutes;
    },
    checkRights(item, user) {
      let isAccessible = true;
      if (!item.requiredRight) {
        return true;
      }
      item.requiredRight.forEach((element) => {
        if (!user[element]) {
          isAccessible = false;
        }
      });
      return isAccessible;
    },
  },
};
</script>
